export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/c239755bda8554c3c2c3a880497b48bd.png";